module.exports = __webpack_public_path__ + "static/assets/c4bcb41530611d50b3850ead3d317591.png";